let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4MYjL")).then(() => parcelRequire('hPMWQ'));